<script setup>
/**
 * FormControlMRegistrantsRegistrantsUsername
 * Composition-based wrapper around the standard text form control.
 * Evaluates global organizational configuration flags on mount, contextually
 * dropping its layout visibility if usernames are set to be hidden system-wide.
 */
import {computed, onMounted} from 'vue'
import FormControlTypeText from '@/common/form-control-type/FormControlTypeText.vue'
import {useAppStore} from '@/stores/appStore'

const props = defineProps({
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number, Array],
        default: null
    }
})

const appStore = useAppStore()

const isHidden = computed(() => !!appStore.settings.config?.hide_customers_username_field)

onMounted(() => {
    if (isHidden.value && props.field) {
        props.field.hidden = true
    }
})
</script>

<template>
    <FormControlTypeText v-bind="$props" v-if="!field.hidden"/>
</template>

<style scoped>
/* Presentation and sizing properties are inherited directly from FormControlTypeText */
</style>